import http from './http'
const base = '/Telas/AprovacaoPagamento'
export default {
  async getPending (params) { return (await http.get(`${base}/GetPending`, { params })).data },
  async decide (id, decision, reason) { await http.post(`${base}/Decide/${id}`, { decision, reason }) }
}
